export const TODOS_OS_PASTOS = -1;
export const PASTOS_SEM_CADASTRO = -2;

export const MESSAGE_PASTURE_WITHOUT_RETREAT = "Alerta: Pasto sem cadastro de retiro, ajuste o cadastro para seguir com vínculo.";
